import { render } from "./ModuleList.vue?vue&type=template&id=725a90b8&scoped=true"
import script from "./ModuleList.vue?vue&type=script&lang=js"
export * from "./ModuleList.vue?vue&type=script&lang=js"

import "./ModuleList.vue?vue&type=style&index=0&id=725a90b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725a90b8"]])

export default __exports__